import * as constants from "./constants";

export default function(state, action){
    if (!state || action.type == constants.DISCOUNT_LIST_CLEAR_STORE){

        let oldDiscountList = undefined;
        if(!!state){
            oldDiscountList = state.discountList;
        }

        state = {
            name: "Тест",

            discountListSummury: [],
            discountList: oldDiscountList || [],
            userList: [],
            isLoading: false,
            isSave: false,
            isLoaded: false
        };

    }

    switch(action.type){
        case constants.DISCOUNT_LIST_SUMMURY_LOAD_START:
            return {...state, ...{discountListSummury: [], isLoading: true, error: undefined}};
        case constants.DISCOUNT_LIST_SUMMURY_LOAD_SUCCESS:
            return { ...state, ...{discountListSummury: action.data, isLoading: false}};
        case constants.DISCOUNT_LIST_SUMMURY_LOAD_FAIL:
            return {...state, ...{isLoading: false, error: action.error}};

        case constants.DISCOUNT_LIST_LOAD_START:
            return {...state, ...{discountList: [], isLoading: true, error: undefined}};
        case constants.DISCOUNT_LIST_LOAD_SUCCESS:
            return { ...state, ...{discountList: action.data, isLoading: false}};
        case constants.DISCOUNT_LIST_LOAD_FAIL:
            return {...state, ...{isLoading: false, error: action.error}};

        case constants.DISCOUNT_LIST_REMOVE_START:
            return {...state, ...{isLoading: true}};
        case constants.DISCOUNT_LIST_REMOVE_SUCCESS:
            return { ...state, ...{isLoading: false, isShouldReload: true}};
        case constants.DISCOUNT_LIST_REMOVE_FAIL:
            return {...state, ...{isLoading: true, error: action.error}};

        default:
            return state;
    }
}
